define(
    'connections/process-connection',[
        'jquery',

        'utils/ajax-util',

        'settings',
    ],

    function ($, ajax, settings) {
        /**
         * @class Cart
         */
        return (function () {

            /**
             * @constructor
             */
            function ProcessConnection () {}

            /**
             * Get the ProcessOptions partial view
             *
             * @method getCart
             * @returns {promise}
             */
            ProcessConnection.prototype.getProcessOptions = function() {
                return $.ajax({
                    url: settings.getprocessOptionsUrl,
                    type: 'GET',
                    cache: false
                });
            };

            ProcessConnection.prototype.addProcessOption = function(type) {
                return ajax.post(settings.processOptionsUrl + '/addProcessOption?type=' + type);
            };

            ProcessConnection.prototype.removeProcessOption = function(poId) {
                return ajax.delete(settings.processOptionsUrl + '/removeProcessOption?id=' + poId);
            };

            /**
             * Posts form data for process options.
             * 
             * @param  {String} type     - the type of process option, 'screen', 'transfer', etc.
             * @param  {Object} formData - { id: processOptionId, ... } id is required to update the correct process option,
             *                             the rest of the properties are depending on the type but are mostly similar: 'colors', 'placement', etc.
             * @return {Promise}         - an ajax promise.
             */
            ProcessConnection.prototype.updateProcessOption = function(formData) {
                return ajax.post(settings.processOptionsUrl + '/updateProcessOption', formData);
            };
            
            /**
             * Posts form data for general parameters.
             * 
             * @param  {String} type     - the type of process option, 'screen', 'transfer', etc.
             * @param  {Object} formData - { id: processOptionId, ... } id is required to update the correct process option,
             *                             the rest of the properties are depending on the type but are mostly similar: 'colors', 'placement', etc.
             * @return {Promise}         - an ajax promise.
             */
            ProcessConnection.prototype.updateGeneralParameters = function(formData) {
                return ajax.post(settings.processOptionsUrl + '/updateGeneralParameters', formData);
            };
            
            /**
             * Uploads file data to blob, and saves metadata to cart. If no id is provided the file is 
             * @param  {String} poId      - the id of the process option.
             * @param  {Data} imageData   - the file data to save to blob.
             * @param  {Object} fileData  - the meta data to save on cart.
             * 
             * @return {Promise}          - ajax promise
             */
            ProcessConnection.prototype.uploadDesign = function(poId, imageData, fileData) {
                return ajax.post(settings.processOptionsUrl + '/uploadProcessDesign', { poId: poId, imageData: imageData, fileData: fileData});
            };

            return new ProcessConnection();
        })();
    }
);

